import React, { FC, PropsWithChildren, useState, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogPlan from "../Dialog/DialogPlan";
import { newFeatureDetails } from "../Dialog/PlanFeatures";
// material-ui
import {
  Box,
  Grid,
  Typography,
  Button,
} from "@mui/material";
import {
  IAccountBasicFormInputs,
  ISubscriptions,
} from "../../utils/account.types";
import axios from "../../utils/axios";
import { IOptions } from "../FormFields/CustomSelect";
import LoadingButton from "@mui/lab/LoadingButton";
import { ApiStatus } from "../../utils/api.types";
import { useAppSelector } from "../../store/hooks";

export interface IDialogProps {
  title: string;
  open: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  data?: any;
}


//Custom Setting Dialog Component.
const SettingDialog: FC<PropsWithChildren<IDialogProps>> = ({
  title,
  onClose,
  open,
  children,
  onSubmit,
  data,
}) => {
  const [tabValue, setTabValue] = useState(0);
  const [subscriptionOptions, setSubscriptionOptions] = useState<IOptions[]>(
    []
  );
  const [featuresData, setfeaturesData] = useState({});
  const { status } = useAppSelector((state) => state.account);
  const { register } = useForm({});


  //Fetch Subscriptions on Account form load.
  useEffect(() => {
    let isMounted = true;
    // Method to fetch available subscriptions.
    const fetchSubscriptions = async () => {
      try {
        const response = await axios.get<ISubscriptions>(
          "/api/v1/subscription"
        );
        const { subscriptions = [] } = response.data;

        const options = subscriptions.map(({ _id, plan }) => ({
          label: plan.toUpperCase(),
          value: _id,
        }));

        let featureDetails: Array<any> = [];

        subscriptions.map(({ _id, resources }) => {
          let featuesOptions = resources.map(({ action, displayName }) => {
            return action + ' ' + displayName;
          })
          featureDetails.push(featuesOptions);
          return featureDetails
        });

        setfeaturesData(newFeatureDetails)

        if (isMounted) {
          setSubscriptionOptions(options);
        }
      } catch (error: any) {
        // Empty catch block.
      }
    };
    fetchSubscriptions();
    return () => {
      isMounted = false;
    };
  }, []);

  // use form
  const methods = useForm<IAccountBasicFormInputs>({});

  const handleTabChange = (newValue: number) => {
    setTabValue(newValue);
  };

  const innerSubmit = async (data: any) => {
    const form = new FormData();
    const subscriptionPlan = subscriptionOptions.find((s, i) => {
      return tabValue === i;
    });
    if (subscriptionPlan?.value) {
      form.append("subscription", subscriptionPlan.value);
    }
    onSubmit(form);
  };

  useEffect(() => {
    if (data && subscriptionOptions.length) {
      let tabIndex = subscriptionOptions.findIndex(x => x.label.toLowerCase() === data.subscription['plan'].toLowerCase());
      setTabValue(tabIndex)
    }
  }, [subscriptionOptions, data]);

  return (
    <FormProvider {...methods}>
      <Box
        sx={{ display: "flex", flexDirection: "column", height: "100vh", width: "880px", transition: "width 1s", transitionTimingFunction: "ease-in-out" }}
        component="form"
        onSubmit={methods.handleSubmit(innerSubmit)}
        noValidate
      >
        <DialogTitle>
          <Box sx={{ display: "flex", mt: 2, justifyContent: "space-between", paddingLeft: "15px" }}>
            <Typography variant="h5">{title}</Typography>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Grid container justifyContent="left" spacing={3} >
            <Grid item xs={12} md={12} sm={12}>
              <Grid item xs={12} md={12} sm={12} sx={{ mt: 5, backgroundColor: "#fafafb", borderRadius: "8px", height: 495 }}>
                <DialogPlan
                  featuresData={featuresData}
                  subscriptionOptions={subscriptionOptions}
                  tabValue={tabValue}
                  handleTabs={(val: any) => handleTabChange(val)}
                  register={register}
                />
              </Grid>
            </Grid>
          </Grid>
          {children}
        </DialogContent>

        <DialogActions sx={{ height: "40px", mb: 2 }}>
          <Grid container justifyContent="right" spacing={3} sx={{ mr: '0px', pt: '10px' }}>
            <Grid item xs={8} md={8} sm={8} lg={8}></Grid>
            <Grid item xs={2} md={2} sm={2} lg={2} sx={{ display: "flex", flexDirection: 'row', justifyContent: "flex-end", alignItems: "flex-end", textAlign: "flex-end", marginRight: "-32px" }}>
              <Button variant='outlined' onClick={() => {
                methods.reset();
                onClose();
              }}>Cancel</Button>
            </Grid>
            <Grid item xs={2} md={2} sm={2} lg={2} sx={{ display: "flex", flexDirection: 'row', justifyContent: "flex-end", alignItems: "flex-end", paddingRight: "30px" }}>
              <LoadingButton
                type="submit"
                loading={status === ApiStatus.LOADING}
                variant="contained"
                color="secondary"
              >
                {'Update'}
              </LoadingButton>
            </Grid>
          </Grid>
        </DialogActions>
      </Box>
    </FormProvider>
  );
};

export default SettingDialog;
